import React from 'react'
import { Platform, Dimensions } from 'react-native'
import { SafeAreaProvider } from 'react-native-safe-area-context'

import QuizGameContainer from './QuizGame'

function QuizGame(props) {
    if (Platform.OS === 'web' && Dimensions.get('window').width > 700) {
        return <QuizGameContainer {...props} />
    }
    return <SafeAreaProvider>
        <QuizGameContainer {...props} />
    </SafeAreaProvider>
}
export default QuizGame
